const style = {
  logAndAuditReports: {
    backgroundColor: '#fff',
    minHeight: '100%',
  },
};

export default style;
